// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/packet/package-churn-retention-success-dialog/package-churn-retention-success-dialog.less
// module id = 610
// module chunks = 0